/**
 * SettlementService
 * Service for Settlement entity operations
 * Route: api/settlement
 * Controller: SettlementController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * SettlementService
 * Handles settlement CRUD operations
 * Maps to /api/settlement endpoint
 */
export class SettlementService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SettlementService.DEFAULT_SERVICE_PATH,
            basePath: SettlementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Settlement with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate settlement cache
     * POST /api/settlement/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate settlement cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
SettlementService.DEFAULT_SERVICE_PATH = 'payments';
SettlementService.BASE_PATH = 'api/settlement';
//# sourceMappingURL=SettlementService.js.map